export const LossDmgIcon = (props) => (
  <svg
    className={props.className}
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.43892 7.72573L2.16532 11.4669V17.9137H0.9375V11.2637L2.28296 7.31137L2.28626 7.30256C2.60822 6.444 3.38742 5.84009 4.25262 5.84009H10.228C11.1335 5.84009 11.9589 6.40832 12.2066 7.3363L13.625 11.2577V17.9137H12.3972V11.4729L11.0316 7.69744L11.024 7.66701C10.9334 7.30477 10.6216 7.06791 10.228 7.06791H4.25262C3.97351 7.06791 3.6094 7.28003 3.43892 7.72573Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.55142 14.8442H13.0111V16.0721H1.55142V14.8442Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.55142 9.93286H13.0111V11.1607H1.55142V9.93286Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.55142 12.3884H4.41634V13.6163H1.55142V12.3884Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1462 12.3884H13.0111V13.6163H10.1462V12.3884Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.34222 3.03564C6.34222 3.67506 5.82386 4.19341 5.18444 4.19341C4.54502 4.19341 4.02667 3.67506 4.02667 3.03564C4.02667 2.39622 4.54502 1.87786 5.18444 1.87786C5.82386 1.87786 6.34222 2.39622 6.34222 3.03564ZM5.18444 5.18579C6.37194 5.18579 7.33459 4.22313 7.33459 3.03564C7.33459 1.84814 6.37194 0.885486 5.18444 0.885486C3.99695 0.885486 3.03429 1.84814 3.03429 3.03564C3.03429 4.22313 3.99695 5.18579 5.18444 5.18579Z"
      fill="#231F20"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8741 2.53936L6.83841 2.53936L6.83841 3.53174L10.8741 3.53174L10.8741 2.53936Z"
      fill="#231F20"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.51785 2.96936L9.51785 5.15259L10.5102 5.15259L10.5102 2.96936L9.51785 2.96936Z"
      fill="#231F20"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.65778 4.49121L8.65778 3.03572L7.6654 3.03572L7.6654 4.49121L8.65778 4.49121Z"
      fill="#231F20"
    />
  </svg>
);
